import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Per-route document titles. Any path not listed here (i.e. an unmatched
// route rendered by NotFound) falls back to the "Page Not Found" title.
const routeTitles: Record<string, string> = {
  '/': 'Athena for Partners',
  '/request-account': 'Request an Account | Athena for Partners',
  '/forgot-password': 'Forgot Password | Athena for Partners',
  '/user-migration-teams': 'Athena for Partners',
  '/athena/migrate-account': 'Migrate Your Account | Athena for Partners',
  '/athena': 'Download Athena | Athena for Partners',
  '/adem': 'Download ADEM | Athena for Partners',
};

const NOT_FOUND_TITLE = 'Page Not Found | Athena for Partners';

const useDocumentTitle = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Normalize pathname by removing trailing slash
    const pathname = location.pathname.replace(/\/$/, '') || '/';
    document.title = routeTitles[pathname] ?? NOT_FOUND_TITLE;
  }, [location.pathname]);
};

export default useDocumentTitle;
